/**
 * Format a date string to a localized date-time string
 * @param {string} dateString - ISO date string
 * @returns {string} - Formatted date string
 */
export const formatDateTime = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('de-AT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  };
  
  /**
   * Format a date string to a localized date string
   * @param {string} dateString - ISO date string
   * @returns {string} - Formatted date string
   */
  export const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('de-AT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  };
  
  /**
   * Format a file size in bytes to a human-readable string
   * @param {string|number} size - File size in bytes
   * @returns {string} - Formatted size string
   */
  export const formatFileSize = (size) => {
    if (!size) return '';
    
    // If size is already formatted (e.g. "2.4 MB"), return as is
    if (typeof size === 'string' && size.includes(' ')) {
      return size;
    }
    
    const bytes = typeof size === 'string' ? parseInt(size, 10) : size;
    
    if (isNaN(bytes)) {
      return '';
    }
    
    const units = ['B', 'KB', 'MB', 'GB'];
    let value = bytes;
    let unitIndex = 0;
    
    while (value > 1024 && unitIndex < units.length - 1) {
      value /= 1024;
      unitIndex++;
    }
    
    return `${value.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
  };
  